module.exports = __webpack_public_path__ + "img/link-icon.dab246d8.svg";